import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, commonData } from "@/mixins/index";
import parentStudentList from "./parentStudentList.vue";
export default {
  name: "parentList",
  components: {
    parentStudentList: parentStudentList
  },
  mixins: [loadMoreList, commonData],
  data: function data() {
    return {
      paramsData: {
        phone: '',
        name: ''
      },
      tableData: [],
      total: 0,
      parentId: ''
    };
  },
  created: function created() {
    this.getList(1);
  },
  activated: function activated() {
    this.queryData = this.$route.params;

    if (this.queryData.parentId) {
      this.parentId = this.queryData.parentId;
      this.getList(1, true);
    }
  },
  methods: {
    getList: function getList() {
      var _arguments = arguments,
          _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var page, isSearch;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                page = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : 1;
                isSearch = _arguments.length > 1 ? _arguments[1] : undefined;
                _this.paramsData.page = page;

                if (isSearch) {
                  _this.paramsData.id = _this.parentId;
                } else {
                  _this.paramsData.id = '';
                }

                _this.$api.getParentsAll(_this.paramsData).then(function (res) {
                  if (res.code == 200) {
                    _this.tableData = res.data.data;
                    _this.total = res.data.total;
                  }
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};